import { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHome, faUser, faPersonFalling} from '@fortawesome/free-solid-svg-icons';

import '../css/style.css';
import '../css/bootstrap.css';

function TcfLabor() {
  var hum = JSON.parse(localStorage.getItem('zwavejs2mqtt/2/49/0/Humidity'));
  var temp = JSON.parse(localStorage.getItem('zwavejs2mqtt/2/49/0/Air_temperature'));
  var voc = JSON.parse(localStorage.getItem('zwavejs2mqtt/2/49/0/Volatile_Organic_Compound_level'));
  var co2 = JSON.parse(localStorage.getItem('zwavejs2mqtt/2/49/0/Carbon_dioxide_CO_level'));
  var door = JSON.parse(localStorage.getItem('zwavejs2mqtt/3/113/0/Access_Control/Door_state'));// 22=open; 23=closed;
  var doorstate;
  var plug = JSON.parse(localStorage.getItem('zwavejs2mqtt/4/49/0/Power'));
  var smoke = JSON.parse(localStorage.getItem('zwavejs2mqtt/5/113/0/Smoke_Alarm/Sensor_status'));// 0=idle;
  var smokestate;
  var flood = JSON.parse(localStorage.getItem('zwavejs2mqtt/6/113/0/Water_Alarm/Sensor_status'));// 0=idle;
  var floodstate;
  var motion = JSON.parse(localStorage.getItem('zwavejs2mqtt/7/113/0/Home_Security/Motion_sensor_status'));// 0=idle; 8=motion
  var motionstate;
  if (door===null){doorstate=23}else{doorstate=door.value}
  if (smoke===null){smokestate=0}else{smokestate=smoke.value}
  if (flood===null){floodstate=0}else{floodstate=flood.value}
  if (motion===null){motionstate=0}else{motionstate=motion.value}

  const [counter, setCounter] = useState(0)

  useEffect(() => {
    let interval
    const updateCounter = () => {
      setCounter(currentValue => currentValue + 1)
    }
    interval = setInterval(() => {
      updateCounter()
    }, 500)
    return () => {
      // Clear the interval when component is unmounted
      clearInterval(interval)
    }
  }, [])


  return (
      <div className="TcfLabor">
        <div>
          <section id="home-top-menu">
            <div className="container-fluid" style={{height: '10vh'}}>
              <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <Link to="/" className="navbar-brand">
                  <img src="img/dh40-logo.png" style={{height: '8vh'}} alt="DeinHaus4.0 Logo - Länger Leben Zuhause Niederbayern" />
                </Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon" />
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                  <ul className="navbar-nav">
                    <li className="nav-item active">
                      <Link to="/tcflabor" className="nav-link" style={{color: '#ED7D31'}}><FontAwesomeIcon icon={faHome} /> Hausdaten</Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/tcfwatch" className="nav-link"><FontAwesomeIcon icon={faUser} /> Gesundheitsdaten</Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/falldetection" className="nav-link"><FontAwesomeIcon icon={faPersonFalling} /> Sturzerkennung</Link>
                    </li>
                  </ul>
                </div>
                <img src="img/Ministerium_logo.png" style={{height: '6vh', selfAlign: 'right'}} alt="Förderlogo des Bayerischen Staatsministeriums für Gesundheit und Pflege" />
              </nav>
            </div>
          </section>
          <section id="homedata">
            <div id="grundriss" className="container-fluid">
              <img src="img/dh40-grundriss.png" alt="Grundriss TCF Labor" />
              <div id="homepin-1" className="box">
                <div className="text-lang homepin-text">
                  <p>Bewegungsmelder</p>
                  <h4>{ motionstate===0 ? 'Keine Bewegung' : 'Bewegung !!!' }</h4>
                </div>
              </div>
              <div id="homepin-4" className="box">
                <div className="text-kurz homepin-text">
                  <p>WallPlug</p>
                  <h4>{plug===null ? '80' : plug.value}W</h4>
                </div>
              </div>
              <div id="homepin-5" className="box">
                <div className="text-mittel homepin-text">
                  <p>Tür-/Fensterkontakt</p>
                  <h4>{ doorstate===23 ? 'geschlossen' : 'offen' }</h4>
                </div>
              </div>
              <div id="homepin-7" className="box">
                <div className="text-kurz homepin-text">
                  <p>Luftfeuchtigkeit</p>
                  <h4>{hum===null ? '45' : hum.value}%</h4>
                </div>
              </div>
              <div id="homepin-8" className="box">
                <div className="text-lang homepin-text">
                  <p>Überflutungssensor</p>
                  <h4>{ floodstate===0 ? 'Keine Überflutung' : 'Überflutung !!!' }</h4>
                </div>
              </div>
              <div id="homepin-9" className="box">
                <div className="text-mittel homepin-text">
                  <p>Luftgütesensor</p>
                  <p style={{marginBottom: '0px'}}>CO2-äq</p><h4>{co2===null ? '400' : co2.value}ppm</h4>
                  <p style={{marginBottom: '0px'}}>VOC</p><h4>{voc===null ? '6' : voc.value}ppm</h4>
                </div>
              </div>
              <div id="homepin-11" className="box">
                <div className="text-mittel homepin-text">
                  <p>Rauchmelder</p>
                  <h4>{ smokestate===0 ? 'Kein Rauch' : 'Rauch !!!' }</h4>
                </div>
              </div>
              <div id="homepin-12" className="box">
                <div className="text-kurz homepin-text">
                  <p>Raumtemperatur</p>
                  <h4>{temp===null ? '22' : temp.value}°C</h4>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
  );
}

export default TcfLabor;
